export const POST_MDB_CONFIG = 'POST_MDB_CONFIG'

export const GET_REQUEST_TOKEN = 'GET_REQUEST_TOKEN'
export const GET_SESSION = 'GET_SESSION'
export const DELETE_SESSION = 'DELETE_SESSION'
export const GET_GUEST_SESSION = 'GET_GUEST_SESSION'
export const TOGGLE_LOG_IN_STATUS = 'TOGGLE_LOG_IN_STATUS'
export const GET_USER_DETAILS = 'GET_USER_DETAILS'

export const POST_MOVIE_GENRES = 'POST_MOVIE_GENRES';
export const POST_TV_GENRES = 'POST_TV_GENRES';

export const SET_ITEM_TYPE_MOVIE = 'SET_ITEM_TYPE_MOVIE';
export const SET_ITEM_TYPE_TV = 'SET_ITEM_TYPE_TV';

export const POST_MOVIES_NOWPLAYING = 'POST_MOVIES_NOWPLAYING'
export const POST_MOVIES_POPULAR = 'POST_MOVIES_POPULAR'
export const POST_MOVIES_TOP_RATED = 'POST_MOVIES_TOP_RATED';
export const POST_MOVIES_UPCOMING = 'POST_MOVIES_UPCOMING';
export const GET_MOVIE_DETAILS = 'GET_MOVIE_DETAILS';
export const GET_MOVIE_CREDITS = 'GET_MOVIE_CREDITS';
export const GET_MOVIE_TRAILERS = 'GET_MOVIE_TRAILERS';
export const GET_MOVIE_REVIEWS = 'GET_MOVIE_REVIEWS';
export const GET_MOVIE_FAVORITES = 'GET_MOVIE_FAVORITES';
export const GET_MOVIES_RATED = 'GET_MOVIES_RATED';
export const RATE_MOVIE = 'RATE_MOVIE';

export const POST_TV_AIRING_TODAY = 'POST_TV_AIRING_TODAY';
export const POST_TV_POPULAR = 'POST_TV_POPULAR';
export const POST_TV_ON_THE_AIR = 'POST_TV_ON_THE_AIR';
export const POST_TV_TOP_RATED = 'POST_TV_TOP_RATED';
export const GET_TV_DETAILS = 'GET_TV_DETAILS';
export const GET_TV_CREDITS = 'GET_TV_CREDITS';
export const GET_TV_TRAILERS = 'GET_TV_TRAILERS';
export const GET_TV_REVIEWS = 'GET_TV_REVIEWS';
export const GET_TV_FAVORITES = 'GET_TV_FAVORITES';
export const GET_TV_RATED = 'GET_TV_RATED';

export const GET_PEOPLE_DETAILS = 'GET_PEOPLE_DETAILS';
export const GET_PEOPLE_COMBINED_CREDITS = 'GET_PEOPLE_COMBINED_CREDITS';
export const GET_PEOPLE_POPULAR = 'GET_PEOPLE_POPULAR';

export const GET_DISCOVER = 'GET_DISCOVER';

export const TOGGLE_NAV = 'TOGGLE_NAV';
export const SEARCH_DATA = 'SEARCH_DATA';
export const POST_SEARCH_RESULTS = 'POST_SEARCH_RESULTS';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js